/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import { useEffect, useState } from "react";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { getRequest } from '../../../../../helpers/axiosClient';
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, Box, FormControlLabel, Switch } from "@mui/material";
import productActions from "../../../../Product/Product/redux/actions";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';
import productSetupActions from "../../../../Product/Setup/redux/actions";

export const StockValueReport = (props) => {
    const { visible, onStockValueVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);
    const [filterValues, setFilterValues] = useState({});

    const dispatch = useDispatch();
    const [reportOpen, setReportOpen] = useState(false);
    const [stockValueData, setStockValueData] = useState([]);
    const [loading, setLoading] = useState(false);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const stockValueFilter = (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            let filter = { ["and"]: [] };

            if (filterValues?.product?.id) {
                filter['and'].push({ productId: filterValues?.product?.id });
            }



            let f = {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: 'id desc',
            }

            if (filterValues?.group?.id) {
                f['where'].groupId = filterValues?.group?.id;
            }
            console.log(f);
            let response = getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/summary?filter=${encodeURIComponent(JSON.stringify(f))}`);
            response.then(payload => {
                let data = payload?.data || [];
                if (!filterValues?.zeroQuantity) {
                    data = data.filter(el => el.physicalQtyUnit >= 0);
                }
                setStockValueData(data);
                setReportOpen(true);
                setLoading(false);
            }).catch(error => {
                // Handle any errors
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (visible) {
            dispatch({
                type: productSetupActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                    order: 'id desc'
                }
            });
            productApi();
        }
    }, [visible])

    const handleClose = () => {
        setFilterValues({});
        onStockValueVisible(false);
        onMenuTitle('');
    }

    const stockValueTitle = (values) => {
        return (
            <>
                {values?.group?.name && (
                    <div>Product Group: {values.group.name}</div>
                )}
                {values?.product?.productName && (
                    <div style={{ marginTop: 10 }}>Product: {values.product.productName}</div>
                )}
            </>
        );
    };

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const changeHandler = (e, name = '', relation = false) => {
        if (relation) {
            setFilterValues({
                ...filterValues,
                [name]: e
            });
        } else {
            setFilterValues({
                ...filterValues,
                [name]: e
            });
        }
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => stockValueFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <AutoCompleteComponent
                                name={["All Products Group"]}
                                placeholder="Please Select Products Group"
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={productGroupDetails}
                                parentValue={customObject(productGroupDetails, filterValues?.group?.id)}
                                position={"bottom"}
                                customClasses={classes.customFilterNone}
                                id={idNamingConversion('All Products Group', 'stockValue', 'DropDown')}
                                onChangeText={(data) => {
                                    if (data === '') {
                                        changeHandler({}, 'group', true);
                                    }
                                }}
                                onChange={(data) => changeHandler(data, 'group', true)}
                            />
                            <AutoCompleteComponent
                                name={`Product `}
                                heads={[{ key: "productName", name: "Product Name" },
                                { key: "code", name: "Product Code" },
                                { key: "productId", name: "Product ID" }]}
                                details={myProductdetails}
                                id={idNamingConversion("Product", "stockValue", "DropDown")}
                                parentValue={customObject(myProductdetails, filterValues?.product?.id)}
                                onChange={(data) => changeHandler(data, 'product', true)}
                                position="bottom"
                                searchType={(s) => productApi(s)}
                                customClasses={classes.margin30t}
                            />
                            <FormControlLabel
                                classes={{
                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                }}
                                id={idNamingConversion('Quantity', 'stockValue', 'Radio')}
                                control={<Switch size='small'
                                    className={clsx(classes.customSwitch)}
                                    onChange={(e) => changeHandler(!filterValues.zeroQuantity, 'zeroQuantity')}
                                    checked={filterValues.zeroQuantity}
                                />}
                                label="Include Zero Quantity & Less"
                                labelPlacement="top"
                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title}</h4>
                            <p className={classes.downloadsHeading}>{stockValueTitle(filterValues)}</p>
                        </div>
                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={3}><h6 style={{ fontSize: 14 }}>Product ID</h6></Col>
                            <Col span={5}><h6 style={{ fontSize: 14 }}>Product Description</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Unit Qty.</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Unit</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>SKU Qty.</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>SKU Unit</h6></Col>
                            <Col span={3}><h6 style={{ fontSize: 14 }}>Cost Amount</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>MRP</h6></Col>
                            <Col span={3}><h6 style={{ fontSize: 14 }}>Sales Value</h6></Col>
                        </Row>
                        {
                            stockValueData?.length > 0 ? stockValueData.map((data, i) => (
                                <Row className={clsx(classes.bill, 'no-break')}>
                                    <Col span={3}><p style={{ fontSize: 14 }}>{data?.serialNumber || ''}</p></Col>
                                    <Col span={5}><p style={{ fontSize: 14, padding: "0 5px" }}>{data?.productName}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.physicalQtyUnit || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.unitName || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.physicalQtySkuUnit || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.skuUnitName || '---'}</p></Col>
                                    <Col span={3}><p style={{ fontSize: 14 }}>{data?.costAmount ? `₹ ${currencyFormat(data?.costAmount || 0)}` : '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.mrp ? `₹ ${currencyFormat(data?.mrp || 0)}` : '---'}</p></Col>
                                    <Col span={3}><p style={{ fontSize: 14 }}>{data?.mrp ? `₹ ${currencyFormat((data?.physicalQtyUnit * data?.mrp))}` : '---'}</p></Col>
                                </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                        }
                    </>
                }
                businessDetails={businessDetails}
                reportType={'landscape'}
                handleClose={() => {
                    setReportOpen(false);
                    stockValueTitle('');
                }}
            />
        </>
    )
}
